export function stripQuery(url: string) {
	return url.split('?')[0];
}
